import type { Locales } from 'app/helpers/createLocalesContext';
import { translation } from 'app/helpers/createLocalesContext';
import { Values, Errors } from './types';

export const PASSWORD_INPUT_PATTERN = /^[a-zA-Z0-9!@#$&*]{0,20}$/;

export const isPasswordInFormat = (password: string): boolean => {
  const isInFormat = /^[a-zA-Z0-9!@#$&*]{8,20}$/.test(password);
  const isLetters = /[a-zA-Z]/.test(password);
  const isDigits = /\d/.test(password);
  const isUppercase = /[A-Z]/.test(password);
  const isLowercase = /[a-z]/.test(password);
  const isSymbols = /[!@#$&*]/.test(password);

  return isInFormat && ((isUppercase && isLowercase) || (isLetters && isDigits) || isSymbols);
};

const usePasswordValidation = (values: Values, locales: Locales): [boolean, Errors] => {
  const errors: string[] = [];
  const { password } = values;

  if (!isPasswordInFormat(password)) errors.push(translation(locales, 'password.hint'));
  if (password === values.login) errors.push(translation(locales, 'password.must_not_eq_login'));

  return [!errors.length, { password: errors }];
};

export default usePasswordValidation;
